import { collection, query, where, getDocs } from 'firebase/firestore'
import { fs } from '../Services/firebase'


export function getAllUsers() {
  return new Promise((resolve, reject) => {
    fs.collection('users')
      .get()
      .then(querySnapshot => {
        let users = [];
        querySnapshot.forEach(doc => {
          users.push(doc.data())
        })
        resolve(users);
      })

  })
}

export function getUserByEmail(email) {
  const q = fs()
    .collection('users')
    .where('email', '==', email)
    .get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, ' => ', doc.data())
      })
    })
}

export function getUserById(id) {
  return new Promise((resolve, reject) => {

  fs.collection('users')
    .where('userId', '==', id)
    .get()
    .then(querySnapshot => {
      let user = [];
      querySnapshot.forEach(doc => {
        user.push(doc.data())
      })
      resolve(user);
    })

  })
}

export function editUser(userData) {
  return new Promise((resolve, reject) => {
    let userRef = fs.collection("users").doc(userData.userId);
    return userRef.update(userData)
      .then(() => {
        resolve('ok');
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });

  })
}

export function deleteUser(id) {
  return new Promise((resolve, reject) => {
    fs.collection("users").doc(id).delete().then(() => {
      resolve('ok');
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });

  })
}

export function getUsersCount() {
  return new Promise((resolve, reject) => {
    fs.collection('users')
      .get()
      .then(querySnapshot => {
        resolve(querySnapshot.size);
      })

  })
}